module.exports = __webpack_public_path__ + "img/icon_submenu13.e65f928b.svg";